const Colors = {
   'localhost': ['#BB0A30', '#B6B1A9'],
   'temp': ['#CCFF33', '#4FABE6', '#E2474F', '#3CC453', '#F79A3A', '#A91Dff', '#E2474F'],
   'audi.smartintel.io': ['#BB0A30', '#B6B1A9']
}

module.exports = Colors


// WEBPACK FOOTER //
// ./src/constants/colors.js